import React from 'react';
import { Card } from '@multifarm/widget-components';
// Components
import { ChartCardHeader } from './header/ChartCardHeader';
// Styles
import './chart-card.scss';
export const ChardCard = ({ title, rangeOptions, children }) => {
    return (React.createElement(Card, { className: "chart-card", title: title, headerComponent: React.createElement(ChartCardHeader, { rangeOptions: rangeOptions }) }, children));
};
